import { Controller } from 'react-hook-form';
import { Fragment } from 'react/jsx-runtime';

import { FormItem, Toggle, ToggleLayout } from '@ingrid/luterkort-react';

import { ValidateSchema } from '../../create/validate';
import { DynamicPath, useCarrierContractFormContext } from '../../types';
import { useUISchema } from '../hooks';
import { Schema } from '../queries';
import { SchemaFormSubText } from './schema-form-sub-text';

interface Props {
  disabled?: boolean;
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormBoolean({ schemaId, schema, disabled, path = '' }: Props) {
  const { control } = useCarrierContractFormContext();
  const { defaultValue } = useUISchema({ schemaId, path });

  return (
    <FormItem.Root>
      <Controller
        rules={ValidateSchema(path, schemaId, schema)}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        defaultValue={defaultValue as any}
        name={path as DynamicPath}
        control={control}
        render={({ field, fieldState }) => {
          return (
            <Fragment>
              <FormItem.Control invalid={fieldState.invalid}>
                <ToggleLayout.Row>
                  <Toggle
                    onCheckedChange={val => field.onChange(val)}
                    aria-invalid={fieldState.invalid}
                    aria-label={schema.title}
                    checked={!!field.value}
                    disabled={disabled}
                  />

                  <ToggleLayout.Stack>
                    <ToggleLayout.Label>{schema.title}</ToggleLayout.Label>
                  </ToggleLayout.Stack>
                </ToggleLayout.Row>
              </FormItem.Control>

              <SchemaFormSubText schema={schema} path={path} />
            </Fragment>
          );
        }}
      />
    </FormItem.Root>
  );
}
